import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {useTranslation} from 'react-i18next';
import FileViewer from './FileViewer';

interface FilePreviewDialogProps {
    open: boolean,
    onClose?: () => void,
    docId: number,
    fileName: string,
    onClick?: (e: React.MouseEvent) => void
}

const FilePreviewDialog: React.FC<FilePreviewDialogProps> = ({open, onClose, docId, fileName}) => {
    const {t} = useTranslation();

    const handleConfirm = () => {
        onClose?.();
    };

    const stopPropagation = (e: React.MouseEvent)=> {
        e.stopPropagation();
    }

    return (
        <Dialog onClick={stopPropagation} open={open} aria-labelledby="session-expired-title" maxWidth='xl'>
            <DialogTitle id="session-expired-title">{fileName}</DialogTitle>
            <DialogContent>
                <FileViewer fileId={String(docId)} fileName={fileName}></FileViewer>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleConfirm}>
                    {t('common.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FilePreviewDialog;
